import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';

export const MIRAMARPRAPOSEDTOC_LAYER_ID = 'miramarPraposedTOCLayer';

export const CATEGORY_COLORS = {
  'Transit Oriented Corridor': [204, 97, 176],
};

const layerConfig = {
  title: 'Proposed Transit Oriented Corridor',
};

function MiramarPraposedTOCLayer() {
  const dispatch = useDispatch();
  const { miramarPraposedTOCLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, miramarPraposedTOCLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (miramarPraposedTOCLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: MIRAMARPRAPOSEDTOC_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: miramarPraposedTOCLayer.visible,
      opacity: miramarPraposedTOCLayer.opacity,

      getFillColor: [204, 97, 176],
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: MIRAMARPRAPOSEDTOC_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Proposed Transit Oriented Corridor',
              includeColumns: [
                'Development_Project_Type',
                'Project_Proposed_Units',
                'Project_Proposed_Total_Square_Footage',
              ],
            }),
          };
        }
      },
    });
  }
}

export default MiramarPraposedTOCLayer;
